// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";

Alpine.directive("hero-slider", (element, {}, { cleanup }) => {
  const OPTIONS = { align: "start", inViewThreshold: 0.1, loop: true } as const;

  const dom = {
    containerNode: ensureHTMLElement(element.querySelector(".c-hero-slider__slider-container")),
    viewportNode: ensureHTMLElement(element.querySelector(".c-hero-slider__slider-viewport")),
    nextBtnNode: ensureHTMLElement(element.querySelector(".c-hero-slider__btn-next")),
    headerSlides: element.querySelectorAll<HTMLElement>(".c-hero-slider__header-slide"),
    headerSlidesContainer: element.querySelectorAll<HTMLElement>(".c-hero-slider__header"),
  };

  if (dom.headerSlides.length < 4) {
    Array.from(dom.containerNode.querySelectorAll<HTMLElement>(".c-hero-slider__slider-slide")).forEach(
      (slide) => dom.containerNode.appendChild(slide.cloneNode(true)),
    );

    Array.from(dom.headerSlides).forEach((slide) =>
      dom.headerSlidesContainer[0].appendChild(slide.cloneNode(true)),
    );

    dom.headerSlides = element.querySelectorAll<HTMLElement>(".c-hero-slider__header-slide");
  }

  const emblaApi = EmblaCarousel(dom.viewportNode, OPTIONS, [ClassNames()]);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, {
    nextBtn: dom.nextBtnNode,
  });

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);

  emblaApi.on("select", () => {
    const selectedSlide = emblaApi.selectedScrollSnap();
    dom.headerSlides.forEach((slide, index) => {
      slide.dataset.current = index === selectedSlide ? "true" : "false";
    });
  });

  cleanup(() => {
    emblaApi.destroy();
  });
});
